module.exports = __webpack_public_path__ + "static/media/caros-bold.a7117e40.woff2";